import ArticleTemplate from "@/components/article/ArticleTemplate";
export default function Zippay() {
  return <ArticleTemplate articleName={"SafeOnlineShopping"} />;
}
